export const environment = {
    production:true,
    urlApiEndPointV3: 'https://apiformulas-demo.healthfinder.es/'
}
